import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-170" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-171" data-mp="13vjdgd8s8gue">
        <h2 className="text-center font-display text-[1.6rem] font-bold uppercase leading-none text-white sm:text-[2.2rem]" data-id="element-172" data-mp="18tuo2q6wivdo">
          DOES THIS SOUND <span className="text-safety" data-id="element-173" data-mp="1dmnt7f6a85qa">FAMILIAR?</span>
        </h2>
        <p className="mt-1.5 text-center text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.95rem]" data-id="element-174" data-mp="1ikxpjt3qtcdh">
          You walk through a workplace looking for safety issues—but there are dozens of conditions,
          work activities, pieces of equipment, access points, storage areas and potential hazards
          competing for your attention.
        </p>
        <div className="mt-2 space-y-1.5" data-id="element-175" data-mp="1whummcagfq2t">
          {painPoints.map(p => <div key={p.title} className="rounded-r-md border-l-4 border-warning bg-carbon py-2 pl-2.5 pr-2" data-id="element-176" data-mp="3te1wnd11l8yn">
              <h3 className="text-[0.76rem] font-extrabold uppercase leading-tight text-white sm:text-[0.95rem]" data-id="element-177" data-mp="280i2uhvbx89">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-mist sm:text-[0.9rem]" data-id="element-178" data-mp="2dnvjuce3p3f8">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}